import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ApiService } from "src/app/service/api-service/api-service.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-edit-customer-care",
  templateUrl: "./edit-customer-care.component.html",
  styleUrls: ["./edit-customer-care.component.css"],
})
export class EditCustomerCareComponent implements OnInit {
  customerCareDetails: any = {};

  registerForm: FormGroup;
  submitted = false;

  loader = false;
  msg: String;
  customerId;

  constructor(
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.customerId = this.activatedRoute.snapshot.paramMap.get("id");
    console.log("customerId: ", this.customerId);
    this.getCustomerCareDetails();
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      marketedBy: ["", Validators.required],
      email: ["", [Validators.email, Validators.required]],
      phoneNo: ["", Validators.required],
      address: ["", Validators.required],
    });
  }

  getCustomerCareDetails() {
    this.loader = true;
    this.apiService
      .get("company/customer-care/details?id=" + this.customerId, true)
      .subscribe(
        (res: any) => {
          this.loader = false;
          if (res.status == 200 && res.body.success == 1 && res.body.data) {
            this.customerCareDetails = res.body.data;
            this.registerForm.patchValue({
              marketedBy: this.customerCareDetails.marketed_by,
              email: this.customerCareDetails.email,
              phoneNo: this.customerCareDetails.phone_no,
              address: this.customerCareDetails.address,
            });
          } else {
            this.router.navigate(["/customer-care"]);
          }
        },
        (err) => {
          this.loader = false;
          this.router.navigate(["/customer-care"]);
        }
      );
  }

  get f() {
    return this.registerForm.controls;
  }

  onSave() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }

    this.loader = true;

    this.apiService
      .put(
        "company/customer-care/edit/" + this.customerCareDetails.id,
        this.registerForm.value,
        true
      )
      .subscribe(
        (res: any) => {
          this.loader = false;
          if (res.status == 200 && res.body.success == 1) {
            this.router.navigate(["/customer-care"]);
          } else {
            this.msg = res.body.message;
            setTimeout(() => {
              this.msg = null;
            }, 7000);
          }
        },
        (err) => {
          this.loader = false;
          this.msg =
            "Due to internal server issue, you can't edit customer care details!";
          setTimeout(() => {
            this.msg = null;
          }, 7000);
        }
      );
  }
}
